// jQuery
require('jquery');

// jQuery UI
require('jquery-ui');

// JQuery components
require('jquery-ui/ui/position.js');
require('jquery-ui/ui/widgets/mouse.js');
require('jquery-ui/ui/widgets/sortable.js');
require('jquery-ui-touch-punch');
require('jquery-contextmenu');
require('jquery-contextmenu/dist/jquery.contextMenu.css');

// Mark library
require('mark.js/dist/jquery.mark.js');

// Bootstrap
require('popper.js');
require('bootstrap');
require('bootstrap-3-typeahead');
require('bootstrap4-toggle');
require('bootstrap4-toggle/css/bootstrap4-toggle.min.css');

// Select 2
require('select2');
require('select2/dist/css/select2.css');

// Font awesome
require('font-awesome/css/font-awesome.css');

// D3
require('d3');

// DataTables JS
require('datatables.net');
require('datatables.net-bs4');
require('datatables.net-responsive');

// DataTables CSS
require('datatables.net-bs4/css/dataTables.bootstrap4.css');
require('datatables.net-responsive-bs4/css/responsive.bootstrap4.css');

// Custom vendor CSS
require('../css/vendor.scss');
